const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const EnragedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'enraged';
	condition.ConditionClass = EnragedCondition;

	const extant = BattleCalc.getCondition( owner, 'enraged' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = EnragedCondition

EnragedCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return EnragedCondition(instigator, owner, battleState, remainingDuration);
};
